'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiEject = function TiEject(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm21.7 29.2c-4.2 0-7.5-3.4-7.5-7.5 0-1-0.8-1.7-1.7-1.7s-1.7 0.7-1.7 1.7c0 5.9 4.9 10.8 10.9 10.8s10.8-4.9 10.8-10.8-4.9-10.9-10.8-10.9c-1 0-1.7 0.8-1.7 1.7s0.7 1.7 1.7 1.7c4.1 0 7.5 3.3 7.5 7.5s-3.4 7.5-7.5 7.5z m-3.9-22.5c0.9 0 1.6 0.7 1.6 1.6s-0.7 1.7-1.6 1.7h-5.4l9.6 9.7c0.7 0.6 0.7 1.7 0 2.3-0.3 0.3-0.7 0.5-1.2 0.5s-0.8-0.2-1.1-0.5l-9.7-9.6v5.4c0 0.9-0.7 1.6-1.7 1.6s-1.6-0.7-1.6-1.6v-11.1h11.1z' })
        )
    );
};

exports.default = TiEject;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/eject.js
// module id = 3068
// module chunks = 0